import { render, staticRenderFns } from "./EditarCupom.vue?vue&type=template&id=bfb01aca"
import script from "./EditarCupom.vue?vue&type=script&lang=js"
export * from "./EditarCupom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports